/**
 * Opens Tidio live chat from custom CTAs (e.g. Personal stylist block).
 */
(function () {
  function openTidioChat() {
    if (window.tidioChatApi && typeof window.tidioChatApi.open === 'function') {
      window.tidioChatApi.open();
      return true;
    }
    return false;
  }

  function onChatClick(event) {
    event.preventDefault();
    if (openTidioChat()) return;

    function onReady() {
      openTidioChat();
    }

    if (window.tidioChatApi && typeof window.tidioChatApi.on === 'function') {
      window.tidioChatApi.on('ready', onReady);
    } else {
      document.addEventListener('tidioChat-ready', onReady, { once: true });
    }
  }

  function bindButtons() {
    document.querySelectorAll('[data-tidio-chat-open]:not([data-tidio-bound])').forEach(function (trigger) {
      trigger.setAttribute('data-tidio-bound', 'true');
      trigger.addEventListener('click', onChatClick);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindButtons);
  } else {
    bindButtons();
  }

  document.addEventListener('shopify:section:load', bindButtons);
})();
